import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const questionsStyles = css`
	margin-bottom: 80px;
	${strictBreakpoints.onlyDesktop} {
		margin-bottom: 57px;
	}
	${strictBreakpoints.onlyTablet} {
		margin-bottom: 44px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-bottom: 32px;
	}
`;
export const questionsHeaderStyles = css`
	margin-top: 60px;
	margin-bottom: 24px;

	${strictBreakpoints.onlyTablet} {
		margin-top: 80px;
	}
	${strictBreakpoints.onlyMobile} {
		margin-top: 40px;
		margin-bottom: 16px;
	}
`;
